import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Link, Redirect } from 'react-router-dom';
import M from 'materialize-css';
import ModalCompanyDialog from '../pyns/ModalCompanyDialog';
import './RemovePlaceSeachByCompany.css';

const refModal = React.createRef();

function RemovePlaceSearchByCompany(props) {
  const [uidCompany, setUidCompany] = useState('');
  const [company, setCompany] = useState(null);
  const [country, setCountry] = useState('');
  const [placeSearch, setPlaceSearch] = useState([]);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [showProcessText, setShowProcessText] = useState(false);
  const { firestore, companies, auth } = props;


  useEffect(() => M.AutoInit(), []);

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const search = (searchTerm) => {
    filterCompanies(country, searchTerm);
  };

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  };

  const getPlaceSearchByCompany = () => {
    if (company) {
      firestore
        .collection('placesSearch')
        .where('uidCompany', '==', uidCompany)
        .where('country', '==', country)
        .get()
        .then((querySnapshot) => {
          const placeSearch = [];
          querySnapshot.forEach((doc) => {
            placeSearch.push({ id: doc.id, ...doc.data() });
          });
          setPlaceSearch(placeSearch);
        })
        .catch((e) => {
          console.log('Error get PlaceSearch', e.message());
        });
    }
  };

  const removePlaceSearch = async () => {
    if (placeSearch && placeSearch.length > 0) {
      const promises = [];
      setShowProcessText(true);
      let query = firestore.collection('placesSearch');
      placeSearch.forEach((p) => {
        promises.push(query.doc(p.id).delete())
      });
      await Promise.all(promises);
      setShowProcessText(false);
    }
  };

  const renderSelectCountry = () => {
    return (
      <div className="row">
        <div className="input-field col s12">
          <select
            className="icons"
            value={country}
            onChange={(e) => {
              updateCountry(e.target.value);
            }}>
            <option value="" disabled>
              Select your Country
            </option>
            <option data-icon="images/ca.svg" value="CA">
              Canada
            </option>
            <option data-icon="images/us.svg" value="US">
              United States
            </option>
            <option data-icon="images/bo.svg" value="BO">
              Bolivia
            </option>
          </select>
          <label>Country</label>
        </div>
      </div>
    );
  };

  if (!auth.uid) {
    return <Redirect to="/signin" />;
  }
  
  return (
    <div className="container">
      <div className="title-section">Remove Place Search by company</div>
      {showProcessText ? <p>Processing...</p> : <div />}
      <div className="row">
        <div className="col s6 card-content">
          {renderSelectCountry()}
          <div className="row">
            <div className="input-field">
              <div className="col s6">
                <label htmlFor="company_uid">Company UID</label>
                {company ? <p>{company.companyName}</p> : <div />}
                <input id="company_uid" type="text" name="uidCompany" value={uidCompany} onChange={(e) => setUidCompany(e.target.value)} />
              </div>
              <div className="col s6">
                <Link to="#" onClick={() => openCompanyDialog()}>
                  Select company
                </Link>
              </div>
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-large" onClick={removePlaceSearch}>
            Remove PlaceSearch
          </button>
        </div>

        <div className="col s6 card-content">
          <div>
            <button onClick={getPlaceSearchByCompany}>Get PlaceSearch</button>
            <p>PlaceSearchs</p>
          </div>
          <div className="placeSearchContainer">
            {placeSearch && placeSearch.length > 0 ? (
              placeSearch.map((p) => {
                return (
                  <div className="card" key={p.id}>
                    <div className="card-content">
                      <p>Id: {p.id}</p>
                      <p>State: {p.state}</p>
                      <p>Type: {p.type}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
      <ModalCompanyDialog refModal={refModal} search={search} currentCompanies={currentCompanies} setUidCompany={setUidCompany} setCompany={setCompany} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(RemovePlaceSearchByCompany);
